// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__yx-4V","title":"Images90_title__1873-","images":"Images90_images__XO0pu"};